import { useEffect, useRef } from 'react'

export const usePrevProp = (prop) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = prop
  })

  return ref.current
}
